import { render } from "./newDeadline.vue?vue&type=template&id=3f678b64&scoped=true"
import script from "./newDeadline.js?vue&type=script&lang=js"
export * from "./newDeadline.js?vue&type=script&lang=js"

import "./newDeadline.vue?vue&type=style&index=0&id=3f678b64&scoped=true&lang=scss"
import "./newDeadline.vue?vue&type=style&index=1&id=3f678b64&lang=scss"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f678b64"]])

export default __exports__